export enum MutationTypes {
  // loading
  SHOW_LOADING = 'SHOW_LOADING',
  HIDE_LOADING = 'HIDE_LOADING',
  // error
  POST_ERROR = 'POST_ERROR',
  CLEAR_ERROR = 'CLEAR_ERROR',
  // auth
  AUTH_REGISTER = 'AUTH_REGISTER',
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  AUTH_UPDATE_PROFILE = 'AUTH_UPDATE_PROFILE',
  // drawer
  TOGGLE_DRAWER = 'TOGGLE_DRAWER',
}
